<script setup lang="ts">
import AppImage from "./AppImage.vue";
</script>

<template>
  <footer id="be-footer" class="be-lowerfooter">
    <div class="be-lowerfooter__bg1 js-scrollfade"></div>
    <div class="be-lowerfooter__inner">
      <div class="be-lowerfooter__l js-scrollfade">
        <nav class="be-lowerfooter__nav">
          <div class="be-lowerfooter__nav__li">
            <a
              href="https://note.bot-express.com/m/m06f8498f3ab1"
              target="_blank"
              rel="noopener"
              class="be-lowerfooter__nav__link"
              ><span>導入事例</span
              ><span class="be-lowerfooter__nav__link__arrow"></span
            ></a>
          </div>
          <div class="be-lowerfooter__nav__li">
            <a
              href="https://note.bot-express.com/"
              target="_blank"
              rel="noopener"
              class="be-lowerfooter__nav__link"
              ><span>公式note</span
              ><span class="be-lowerfooter__nav__link__arrow"></span
            ></a>
          </div>
          <div class="be-lowerfooter__nav__li">
            <a href="/company/" class="be-lowerfooter__nav__link"
              ><span>会社概要</span></a
            >
          </div>
          <div class="be-lowerfooter__nav__li">
            <a href="/recruit/" class="be-lowerfooter__nav__link"
              ><span>採用情報</span></a
            >
          </div>
          <div class="be-lowerfooter__nav__li">
            <a href="/news/" class="be-lowerfooter__nav__link"
              ><span>お知らせ</span></a
            >
          </div>
          <div class="be-lowerfooter__nav__li">
            <a
              href="https://form.bot-express.com/inbox"
              target="_blank"
              rel="noopener"
              class="be-lowerfooter__nav__link"
              ><span>お問い合わせ</span
              ><span class="be-lowerfooter__nav__link__arrow"></span
            ></a>
          </div>
        </nav>
        <p class="be-lowerfooter__address">
          〒105-6923 東京都港区虎ノ門4-1-1 神谷町トラストタワー23階
        </p>
        <div class="be-lowerfooter__foot">
          <div class="be-lowerfooter__foot__link">
            <a
              href="https://bot-express.notion.site/fd5ac5126d4f4b79ae0ad75b8dd923d3"
              target="_blank"
              rel="noopener"
              class="be-textlink"
              >情報セキュリティ方針</a
            >
          </div>
          <div class="be-lowerfooter__foot__link">
            <a
              href="https://bot-express.notion.site/a37097a3f3934ac29dadbf6e263987fc"
              target="_blank"
              rel="noopener"
              class="be-textlink"
              >個人情報保護基本方針</a
            >
          </div>
        </div>
        <div class="be-lowerfooter__foot">
          <div class="be-lowerfooter__foot__link">
            <a
              href="https://bot-express.notion.site/1ffd5f46561980e599d3ef618d5c345f"
              target="_blank"
              rel="noopener"
              class="be-textlink"
              >ウェブサイト利用規約</a
            >
          </div>
        </div>
        <div class="be-lowerfooter__cr">Copyright © Bot Express Inc.</div>
        <div class="be-lowerfooter__mark">
          <span
            ><AppImage
              src="/assets/common/img/isms.png"
              alt="iso認証"
              width="229"
              height="86"
              class="be-resize"
          /></span>
        </div>
      </div>
      <div class="be-lowerfooter__r js-scrollfade">
        <div class="be-lowerfooter__logo">
          <a href="/" class="be-hover"
            ><AppImage
              src="/assets/common/img/logo_tagline.svg"
              alt="株式会社Bot Express"
              width="400"
              height="87"
              class="be-resize"
          /></a>
        </div>
        <ul class="be-lowerfooter__sns">
          <li class="be-lowerfooter__sns__li">
            <a
              href="https://www.facebook.com/BotExpressInc/"
              target="_blank"
              rel="noopener"
              class="be-hover"
              ><AppImage
                src="/assets/common/img/ico_facebook.png"
                alt="facebook"
                width="64"
                height="64"
                class="be-resize"
            /></a>
          </li>
          <li class="be-lowerfooter__sns__li">
            <a
              href="https://twitter.com/BotExpressInc"
              target="_blank"
              rel="noopener"
              class="be-hover"
              ><AppImage
                src="/assets/common/img/ico_twitter.png"
                alt="twitter"
                width="64"
                height="64"
                class="be-resize"
            /></a>
          </li>
          <li class="be-lowerfooter__sns__li">
            <a
              href="https://lin.ee/fwNcITR"
              target="_blank"
              rel="noopener"
              class="be-hover"
              ><AppImage
                src="/assets/common/img/ico_line.png"
                alt="line"
                width="64"
                height="64"
                class="be-resize"
            /></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
